<mat-card *ngIf="!loading" class="mcd-card add-exception-card">
  <mat-card-header class="mcd-card-header-dateModified add-exception-page-header">
    <mat-card-title class="add-exception-page-title-row">
      <button type="button" class="add-exception-back-btn" (click)="goBack()">
        <img src="/assets/images/back to list.svg" alt="" />
        Back
      </button>
      <span class="add-exception-page-title">{{ pageTitle }}</span>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="mcd-card-content add-exception-page-content">
    <div class="add-exception-layout">
      <div class="add-exception-body">
        <div class="form-panel">
          <div class="exception-details-card">
            <div class="exception-details-header">
              <img src="/assets/images/file-new 1.svg" alt="" class="header-icon" />
              <span class="header-title">Exception Details</span>
            </div>

            <form [formGroup]="addendumForm" class="exception-form mcd-grbes-form newForm">
              <div class="form-field-block">
                <label class="grs-field-label">
                  Exception Title<span class="required">*</span>
                  <span class="field-tooltip"></span>
                </label>
                <div class="title">
                  <input class="form-title" formControlName="title" placeholder="Enter Exception Title" />
                </div>
              </div>

              <div class="form-field-block">
                <label class="grs-field-label">
                  Exception Description<span class="required">*</span>
                  <span class="field-tooltip"></span>
                </label>
                <div class="description">
                  <textarea class="textarea" rows="4" formControlName="description"
                    placeholder="Enter exception details..."></textarea>
                  <mat-error *ngIf="
                  addendumForm.get('description').touched &&
                  addendumForm.get('description').hasError('required')
                ">
                    Exception Description is required
                  </mat-error>
                </div>
              </div>

              <div class="form-field-block">
                <label class="grs-field-label">
                  Exception Notes<span class="required">*</span>
                  <span class="field-tooltip"></span>
                </label>
                <div class="description">
                  <textarea class="textarea" rows="3" formControlName="note"
                    placeholder="Enter any additional notes..."></textarea>
                  <mat-error *ngIf="
                  addendumForm.get('note').touched &&
                  addendumForm.get('note').hasError('required')
                ">
                    Exception Notes are required
                  </mat-error>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="form-field-block">
                    <label class="grs-field-label">
                      Status<span class="required">*</span>
                      <span class="field-tooltip"></span>
                    </label>
                    <mat-form-field class="grs-mat-field status-select" appearance="legacy" floatLabel="never"
                      hideRequiredMarker>
                      <mat-select formControlName="status">
                        <mat-option [value]="addendumStatusEnum.Requested">New</mat-option>
                        <mat-option [value]="addendumStatusEnum.Approved">Approved</mat-option>
                        <mat-option [value]="addendumStatusEnum.Rejected">Rejected</mat-option>
                        <mat-option [value]="addendumStatusEnum.Expired">Expired</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-field-block dates">
                    <label class="grs-field-label">
                      Renewal Date<span class="required">*</span>
                      <span class="field-tooltip"></span>
                    </label>
                    <mat-form-field class="grs-mat-field date-field"
                      [class.date-empty]="!addendumForm.get('exceptionRenewalDate').value" appearance="legacy"
                      floatLabel="never" hideRequiredMarker>
                      <input matInput [matDatepicker]="renewalPicker" formControlName="exceptionRenewalDate"
                        [matDatepickerFilter]="dateFilter" />
                      <mat-datepicker-toggle matSuffix [for]="renewalPicker">
                        <img matDatepickerToggleIcon src="/assets/images/date-calender.svg" alt="Calendar"
                          class="date-picker-icon" />
                      </mat-datepicker-toggle>
                      <mat-datepicker #renewalPicker></mat-datepicker>
                      <mat-error *ngIf="
                      addendumForm.get('exceptionRenewalDate').touched &&
                      addendumForm.get('exceptionRenewalDate').hasError('required')
                    ">
                        Renewal date is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="form-field-block dates">
                    <label class="grs-field-label">
                      Requested On<span class="required">*</span>
                      <span class="field-tooltip"></span>
                    </label>
                    <mat-form-field class="grs-mat-field date-field"
                      [class.date-empty]="!addendumForm.get('requestedOn').value" appearance="legacy" floatLabel="never"
                      hideRequiredMarker>
                      <input matInput [matDatepicker]="requestedPicker" formControlName="requestedOn" />
                      <mat-datepicker-toggle matSuffix [for]="requestedPicker">
                        <img matDatepickerToggleIcon src="/assets/images/date-calender.svg" alt="Calendar"
                          class="date-picker-icon" />
                      </mat-datepicker-toggle>
                      <mat-datepicker #requestedPicker></mat-datepicker>
                      <mat-error *ngIf="
                      addendumForm.get('requestedOn').touched &&
                      addendumForm.get('requestedOn').hasError('required')
                    ">
                        Requested date is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-6" *ngIf="isNewStatus()">
                  <div class="form-field-block">
                    <label class="grs-field-label">
                      Country<span class="required">*</span>
                      <span class="field-tooltip"></span>
                    </label>
                    <mat-form-field class="grs-mat-field country-select" appearance="legacy" floatLabel="never"
                      hideRequiredMarker>
                      <mat-select formControlName="country" multiple placeholder="Select country">
                        <mat-option *ngFor="let country of countries" [value]="country.id">
                          {{ country.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="
                      addendumForm.get('country').touched &&
                      addendumForm.get('country').hasError('required')
                    ">
                        Country selection is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-6" *ngIf="showStatusOnField()">
                  <div class="form-field-block dates">
                    <label class="grs-field-label">
                      {{ statusOnLabel }}<span class="required">*</span>
                      <span class="field-tooltip"></span>
                    </label>
                    <mat-form-field class="grs-mat-field date-field"
                      [class.date-empty]="!addendumForm.get('statusOn').value" appearance="legacy" floatLabel="never"
                      hideRequiredMarker>
                      <input matInput [matDatepicker]="statusOnPicker" formControlName="statusOn" />
                      <mat-datepicker-toggle matSuffix [for]="statusOnPicker">
                        <img matDatepickerToggleIcon src="/assets/images/date-calender.svg" alt="Calendar"
                          class="date-picker-icon" />
                      </mat-datepicker-toggle>
                      <mat-datepicker #statusOnPicker></mat-datepicker>
                      <mat-error *ngIf="
                      addendumForm.get('statusOn').touched &&
                      addendumForm.get('statusOn').hasError('required')
                    ">
                        {{ statusOnLabel }} is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="form-field-block" *ngIf="!isNewStatus()">
                <label class="grs-field-label">
                  Country<span class="required">*</span>
                  <span class="field-tooltip"></span>
                </label>
                <mat-form-field class="grs-mat-field country-select" appearance="legacy" floatLabel="never"
                  hideRequiredMarker>
                  <mat-select formControlName="country" multiple placeholder="Select country">
                    <mat-option *ngFor="let country of countries" [value]="country.id">
                      {{ country.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                  addendumForm.get('country').touched &&
                  addendumForm.get('country').hasError('required')
                ">
                    Country selection is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row upload-row">
                <div [class.col-6]="!isNewStatus()" [class.col-12]="isNewStatus()">
                  <div class="form-field-block">
                    <label class="grs-field-label">
                      Exception Document<span class="required">*</span>
                      <span class="field-tooltip"></span>
                    </label>
                    <div class="upload-box" *ngIf="!getRequestedAttachment()?.fileName"
                      (click)="exceptionFileInput.click()">
                      <!-- <img src="/assets/images/upload.svg" alt="" /> -->
                      <span style="color: #3F51B5;font-size: 13px;">Choose document</span><span
                        style="color: #7C7C7C;font-size: 12px;">*Only .doc and .docx files are allowed</span>
                    </div>
                    <div class="uploaded-file-card" *ngIf="getRequestedAttachment()?.fileName">
                      <img src="/assets/images/upload.svg" alt="" class="file-icon" />
                      <div class="file-meta">
                        <a href="javascript:void(0);" (click)="downloadAttachment(getRequestedAttachment())">{{
                          getRequestedAttachment()?.fileName }}</a>
                        <span class="file-size">{{ getAttachmentSize(getRequestedAttachment()) }}</span>
                      </div>
                      <button type="button" class="remove-file" (click)="onRemoveAddendumDocument()">
                        <i class="material-icons">cancel</i>
                      </button>
                    </div>
                    <input hidden type="file" #exceptionFileInput accept=".doc,.docx"
                      (change)="onSelectAAddendumDocument($event)" />
                    <mat-error class="upload-error" *ngIf="invalidFile">{{
                      invalidFileMessage
                      }}</mat-error>
                  </div>
                </div>
                <div class="col-6" *ngIf="!isNewStatus()">
                  <div class="form-field-block">
                    <label class="grs-field-label">
                      Final Document
                      <span class="field-tooltip"></span>
                    </label>
                    <div class="upload-box" *ngIf="!getFinalAttachment()?.fileName" (click)="finalFileInput.click()">
                      <!-- <img src="/assets/images/upload.svg" alt="" /> -->
                      <span style="color: #3F51B5;font-size: 13px;">Choose document</span><span
                        style="color: #7C7C7C;font-size: 12px;">*Only .doc and .docx files are allowed</span>

                    </div>
                    <div class="uploaded-file-card" *ngIf="getFinalAttachment()?.fileName">
                      <img src="/assets/images/upload.svg" alt="" class="file-icon" />
                      <div class="file-meta">
                        <a href="javascript:void(0);" (click)="downloadAttachment(getFinalAttachment())">{{
                          getFinalAttachment()?.fileName }}</a>
                        <span class="file-size">{{ getAttachmentSize(getFinalAttachment()) }}</span>
                      </div>
                      <button type="button" class="remove-file" (click)="onRemoveFinalDocument()">
                        <i class="material-icons">cancel</i>
                      </button>
                    </div>
                    <input hidden type="file" #finalFileInput accept=".doc,.docx"
                      (change)="onSelectFinalDocument($event)" />
                    <mat-error class="upload-error" *ngIf="invalidFinalFile">{{
                      invalidFinalFileMessage
                      }}</mat-error>
                  </div>
                </div>
              </div>

              <div class="form-actions">
                <button type="button" class="btn-cancel" mat-stroked-button (click)="goBack()">
                  Cancel
                </button>
                <button type="button" class="mcd-btn mcd-btn-secondary btn-submit" mat-raised-button
                  (click)="submitTheAddendum()" [disabled]="
                addendumForm.invalid ||
                !getRequestedAttachment()?.fileName ||
                invalidFile ||
                (!isNewStatus() && invalidFinalFile)
              ">
                  {{ isEditMode ? 'Update' : 'Submit' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="sidebar-shell" [class.is-collapsed]="sidebarCollapsed">
        <div class="sidebar-rail" [class.is-collapsed]="sidebarCollapsed">
          <button type="button" class="sidebar-toggle" (click)="toggleSidebar()"
            [matTooltip]="sidebarCollapsed ? 'Expand' : 'Collapse'"
            matTooltipPosition="left"
            [attr.aria-label]="sidebarCollapsed ? 'Expand standard info' : 'Collapse standard info'">
            <i class="material-icons">{{
              sidebarCollapsed ? 'chevron_left' : 'chevron_right'
              }}</i>
          </button>

          <aside class="sidebar-panel" *ngIf="!sidebarCollapsed">
            <div class="sidebar-card standard-info-card">
              <h2 class="sidebar-card-title">Standard Info</h2>
              <ul class="standard-info-list">
                <li class="standard-info-row">
                  <div class="info-left">
                    <span class="reviewPage-icon standard-title"></span>
                    <span class="info-label">Standard Title</span>
                  </div>
                  <span class="info-value">{{ addendum.standard?.title }}</span>
                </li>
                <li class="standard-info-row">
                  <div class="info-left">
                    <span class="reviewPage-icon date"></span>
                    <span class="info-label">New Restaurant</span>
                  </div>
                  <span class="info-value">{{
                    addendum.standard?.newRestaurantsEffectiveFrom | date: 'dd MMMM, yyyy'
                    }}</span>
                </li>
                <li class="standard-info-row">
                  <div class="info-left">
                    <span class="reviewPage-icon date2"></span>
                    <span class="info-label">Existing Restaurants</span>
                  </div>
                  <span class="info-value">{{
                    addendum.standard?.effectiveFrom | date: 'dd MMMM, yyyy'
                    }}</span>
                </li>
                <li class="standard-info-row">
                  <div class="info-left">
                    <span class="reviewPage-icon standardType"></span>
                    <span class="info-label">Standard Type</span>
                  </div>
                  <span class="info-value">{{ addendum.standard?.standardType?.name }}</span>
                </li>
                <li class="standard-info-row">
                  <div class="info-left">
                    <span class="reviewPage-icon createdOn"></span>
                    <span class="info-label">Created On</span>
                  </div>
                  <span class="info-value">{{
                    addendum.standard?.lastModifiedDate | date: 'dd MMMM, yyyy'
                    }}</span>
                </li>
                <li class="standard-info-row">
                  <div class="info-left">
                    <span class="reviewPage-icon category"></span>
                    <span class="info-label">Category</span>
                  </div>
                  <span class="info-value">{{ addendum.standard?.category?.name }}</span>
                </li>
                <li class="standard-info-row standard-info-row-wrap">
                  <div class="info-left">
                    <span class="reviewPage-icon location"></span>
                    <span class="info-label">Location</span>
                  </div>
                  <span class="info-value">{{
                    allLocations || addendum.standard?.locationType?.name || '—'
                    }}</span>
                </li>
                <li class="standard-info-row standard-info-row-wrap">
                  <div class="info-left">
                    <span class="reviewPage-icon Sublocation"></span>
                    <span class="info-label">Sub Location</span>
                  </div>
                  <span class="info-value">{{
                    subLocations || addendum.standard?.subLocationType?.name || '—'
                    }}</span>
                </li>
                <li class="standard-info-row">
                  <div class="info-left">
                    <span class="reviewPage-icon keyContact"></span>
                    <span class="info-label">Key Contact</span>
                  </div>
                  <a *ngIf="keyContactEmail" class="info-value info-link" [href]="'mailto:' + keyContactEmail">{{
                    keyContactEmail }}</a>
                  <span *ngIf="!keyContactEmail" class="info-value">—</span>
                </li>
              </ul>
            </div>

            <div class="sidebar-card">
              <h2 class="sidebar-card-title">Description</h2>
              <p class="standard-description">{{ addendum.standard?.description }}</p>
            </div>

            <button type="button" class="view-standard-btn" (click)="viewCompleteStandard()">
              <img src="/assets/images/Left Link.svg" alt="" />
              View Complete Standard
            </button>
          </aside>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>